import React from "react";
import Logo from "../components/Common/Logo";
import LinkedInSignUp from "../components/LinkedInSignUp/LinkedInSignUp";
const LinkedInSignUpPage=()=>{
    return(
        <>
            <Logo/>
            <LinkedInSignUp/>
        </>
    )
}
export default LinkedInSignUpPage